import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['list', 'template']
  static values = { index: { type: Number, default: 0 } }

  add() {
    // Server-rendered template only — never user input
    const html = this.templateTarget.innerHTML.replaceAll('NEW_RECORD', `${this.#nextIndex()}`)
    this.listTarget.insertAdjacentHTML('beforeend', html)
  }

  remove(event) {
    const row = event.currentTarget.closest('[data-nested-row]')
    if (!row) return

    const idField = row.querySelector('input[name$="[id]"]')
    if (idField) {
      row.querySelector('input[name$="[_destroy]"]').value = '1'
      row.classList.add('hidden')
    } else {
      row.remove()
    }
  }

  #nextIndex() {
    // Strictly increasing numeric index: strong parameters silently drops
    // *_attributes rows whose keys are not integers, and the timestamp avoids
    // any collision with the indexes of the server-rendered rows
    const index = this.indexValue
    this.indexValue = index + 1
    return Date.now() + index
  }
}
